





























































































































import { CartItem } from '@/models/cart/cart-item'
import { formatPrice } from '@/util/format'
import NoveltySection from '@spa/components/organisms/cart/novelty/NoveltySection.vue'
import { WithCheckoutComponentProps } from '@spa/components/pages/order/order/checkout/mixin/with-checkout-component-props'
import PriceSummaryForCheckoutStore from '@spa/components/pages/order/order/checkout/PriceSummaryForCheckoutStore.vue'
import { CheckoutKey } from '@spa/components/pages/order/order/models/checkout-store'
import OrderListItem from '@spa/components/pages/order/order/order-list/read-only/OrderListItem.vue'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Emit } from 'vue-property-decorator'

/**
 * 複数のCheckoutを1回のボタンクリックで実行できるUI
 * 反対はStepByStepCheckout
 */
@Component({
  components: {
    NoveltySection,
    OrderListItem,
    PriceSummaryForCheckoutStore,
  },
})
export default class BulkCheckout extends Mixins<WithCheckoutComponentProps>(WithCheckoutComponentProps) {
  shouldShowNoveltySection(checkoutKey: CheckoutKey): boolean {
    return this.noveltyCampaign !== null &&
      this.noveltyCartItems.length > 0 &&
      // checkoutKeyのcheckoutがノベルティを持っていること
      this.checkoutStore.findByKey(checkoutKey).map(checkout => checkout.noveltyCount).getOrElse(0) > 0
  }

  formatPrice(price: number): string {
    return formatPrice(price)
  }

  excludeNovelties(cartItems: CartItem[]): CartItem[] {
    return cartItems.filter(c => !c.isNovelty)
  }

  @Emit('checkout-all')
  emitCheckoutAll() {
    // nothing
  }

  @Emit('novelty-states-change')
  emitNoveltyStatesChange() {
    // nothing
  }

  @Emit('reset-novelty-selection')
  emitResetNoveltySelection() {
    // nothing
  }
}
